import React, { useState, useEffect } from 'react';
import {
  IonPage,
  IonContent,
  IonInput,
  IonItem,
  IonLabel,
  IonSelect,
  IonSelectOption,
  IonTextarea,
  IonButton,
  IonAlert,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonButtons,
  IonBackButton,
  IonSpinner // Importado para el indicador de carga
} from '@ionic/react';
import { useHistory } from 'react-router-dom';
import Header from "../components/Header";
import Footer from '../components/Footer';
import './PQRS.css';

// const PHP_PROXY_URL_HOME_SECTIONS = 'https://portal.mastinseguridad.com/apisapp/ga_proxy.php';

// const getOrCreateGaClientIdForHome = (): string => {
//   let clientId = localStorage.getItem('ga_client_id');
//   if (!clientId) {
//     clientId = typeof self !== 'undefined' && self.crypto?.randomUUID ? 
//                self.crypto.randomUUID() : 
//                `uuid-${Date.now()}-${Math.random().toString(36).substring(2)}`;
//     localStorage.setItem('ga_client_id', clientId);
//   }
//   return clientId;
// };

// const user = localStorage.getItem('profile') as string;
// const profile = user ? JSON.parse(user) : null;
// const userIdForGa = profile?.id?.toString() ?? undefined; 

// const clientIdForGa = getOrCreateGaClientIdForHome();

// const payloadToProxyHome = {
//   client_id: clientIdForGa,
//   user_id: userIdForGa, 
//   event_name: 'page_view', 
//   event_params: {         
//     page_location: '/pages/CreateTicket',
//     page_title: 'CreateTicket'
//   }
// };

// console.log('Enviando page_view inicial a proxy GA:', payloadToProxyHome);
// fetch(PHP_PROXY_URL_HOME_SECTIONS, {
//   method: 'POST',
//   headers: { 'Content-Type': 'application/json' },
//   body: JSON.stringify(payloadToProxyHome)
// })
// .then(response => {
//   if (!response.ok) {
//     response.json().then(err => console.error('Error desde proxy GA (page_view):', err)).catch(() => console.error('Error desde proxy GA (Home page_view), respuesta no JSON'));
//   } else {
//     response.json().then(data => console.log('Éxito vía proxy GA (page_view):', data)).catch(() => console.log('Éxito vía proxy GA (Home page_view), respuesta no JSON'));
//   }
// })
// .catch(error => {
//   console.error('Error de red contactando proxy GA (page_view):', error);
// });




// Define la interfaz para los props, específicamente el estado de red
interface props {
  netState: boolean;
}

// Define la interfaz para los datos del perfil obtenidos de localStorage
interface ProfileData {
  id?: number;
  full_name?: string;
  email?: string;
  phone?: string;
  property?: {
    name?: string;
  };
}

// Define la interfaz para la respuesta esperada de HubSpot al crear un ticket
interface HubSpotTicketResponse {
  id: string;
  properties: {
    subject: string;
    content: string;
    createdate: string;
    // ... otras propiedades que HubSpot devuelve
  };
  createdAt: string;
  updatedAt: string;
  archived: boolean;
}

// Componente funcional para crear un ticket
const CreateTicket: React.FC<props> = ({ netState }) => {
  const history = useHistory(); // Hook para la navegación
  const [profileData, setProfileData] = useState<ProfileData>({}); // Estado para datos del perfil
  // Estado para los datos del formulario
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    type: '',
    message: '',
    phone: '',
    propertyName: ''
  });
  const [showAlert, setShowAlert] = useState(false); // Estado para mostrar/ocultar la alerta
  const [alertMsg, setAlertMsg] = useState(''); // Mensaje de la alerta
  const [isSubmitting, setIsSubmitting] = useState(false); // Estado para indicar si se está enviando
  const [ticketIdOnSuccess, setTicketIdOnSuccess] = useState<string | null>(null); // Almacena el ID del ticket si la creación fue exitosa

  // Efecto para cargar datos del perfil desde localStorage al montar el componente
  useEffect(() => {
    try {
      const storedProfile = localStorage.getItem('profile');
      if (storedProfile) {
        const profile = JSON.parse(storedProfile);
        setProfileData(profile);
        // Pre-rellenar el formulario con datos del perfil
        setFormData(prevFormData => ({
          ...prevFormData,
          name: profile.full_name || '',
          email: profile.email || '',
          phone: profile.phone || '',
          propertyName: profile.property?.name || ''
        }));
      }
    } catch (error) {
      console.error("Error al cargar el perfil desde localStorage:", error);
    }
  }, []); // El array vacío asegura que se ejecute solo una vez al montar

  // Función para manejar cambios en los inputs del formulario
  const handleChange = (e: any, key: string) => {
    // 'e.detail.value' es específico de los componentes Ionic
    setFormData({ ...formData, [key]: e.detail.value });
  };

  // Función para manejar el envío del formulario
  const handleSubmit = async () => {
    const { name, email, type, message, phone, propertyName } = formData;

    // Validación de campos obligatorios
    if (!name || !email || !type || !message) {
      setAlertMsg("Todos los campos son obligatorios");
      setShowAlert(true);
      return;
    }

    // Validación simple de formato de email
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setAlertMsg("El correo electrónico no es válido.");
      setShowAlert(true);
      return;
    }

    setIsSubmitting(true); // Indicar que se está procesando
    setAlertMsg(''); // Limpiar mensajes previos
    setTicketIdOnSuccess(null); // Resetear ID de éxito

    try {
      // Llamada al backend PHP para crear el ticket
      const response = await fetch('https://biinyugames.com/mastinpqrs/pqrs.php', { // URL de tu script PHP
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          // Datos formateados como espera tu script PHP y HubSpot
          subject: name, // Usa el nombre como asunto o crea uno diferente
          content: message, // El mensaje del usuario
          hs_pipeline: "0", // Pipeline por defecto (ajusta si es necesario)
          hs_pipeline_stage: "1", // Etapa inicial del pipeline (ajusta si es necesario)
          ticket_type: type, // El tipo seleccionado (peticion, queja, etc.)
          // Datos adicionales que tu PHP usa para enriquecer el 'content' o propiedades personalizadas
          name,
          email,
          phone,
          propertyName
        })
      });

      // Procesar la respuesta del backend
      if (response.ok) {
        const responseData: HubSpotTicketResponse = await response.json();
        const ticketId = responseData.id; // Obtener el ID del ticket creado

        if (ticketId) {
          // Guardar el nuevo ID en localStorage junto con los existentes
          let userTicketIds: string[] = [];
          try {
            const storedIds = localStorage.getItem('userTicketIds');
            userTicketIds = storedIds ? JSON.parse(storedIds) : [];
            if (!Array.isArray(userTicketIds)) { // Asegurarse que sea un array
                 userTicketIds = [];
            }
          } catch (e) {
             console.error("Error parsing userTicketIds from localStorage:", e);
             userTicketIds = []; // Resetear si hay error
          }
          userTicketIds.push(ticketId); // Añadir el nuevo ID
          localStorage.setItem('userTicketIds', JSON.stringify(userTicketIds)); // Guardar de nuevo

          console.log("Ticket ID guardado:", ticketId);
          setAlertMsg(`Tu solicitud fue enviada exitosamente. Ticket ID: ${ticketId}`);
          setTicketIdOnSuccess(ticketId); // Guardar ID para redirigir al cerrar la alerta

          // Limpiar campos del formulario después de éxito (opcional, decide qué limpiar)
          setFormData(prev => ({
            ...prev,
            type: '', // Limpia el tipo
            message: '' // Limpia el mensaje
            // Mantén nombre, email, teléfono si vienen del perfil
          }));

        } else {
          // Caso raro: respuesta OK pero sin ID
          setAlertMsg("Tu solicitud fue enviada, pero no se pudo obtener el ID del ticket.");
          console.warn("Respuesta exitosa pero sin ID de ticket:", responseData);
        }
        setShowAlert(true); // Mostrar alerta de éxito o advertencia

      } else {
        // Manejo de errores si la respuesta no fue OK (ej. 4xx, 5xx)
        let errorDetail = `Error ${response.status}`;
        try {
          const errorData = await response.json(); // Intenta leer cuerpo del error como JSON
          console.error("Error desde el backend:", errorData);
          if (errorData.message) {
             errorDetail = errorData.message;
          } else if (errorData.error) {
             errorDetail = errorData.error;
          }
        } catch (jsonError) {
          const errorText = await response.text(); // Si no es JSON, lee como texto
          console.error("Error desde el backend (texto):", errorText);
          if(errorText) errorDetail = errorText;
        }
        setAlertMsg(`Error al crear ticket: ${errorDetail}`);
        setShowAlert(true);
      }
    } catch (err: any) {
      // Manejo de errores de red o de la función fetch misma
      console.error("Error de red o fetch:", err);
      let errorMessage = "Error de red o configuración.";
      if (err instanceof Error) {
          errorMessage = `Error de red: ${err.message}`;
      }
      setAlertMsg(errorMessage);
      setShowAlert(true);
    } finally {
        setIsSubmitting(false); // Volver a habilitar el botón de envío
    }
  };

  // Función que se ejecuta al cerrar la alerta
  const handleAlertDismiss = () => {
      setShowAlert(false); // Ocultar la alerta
      if (ticketIdOnSuccess) { // Si se había guardado un ID de ticket exitoso...
          history.push('/pqrs'); // ...redirige a la página de listado
      }
      setTicketIdOnSuccess(null); // Limpiar el ID de éxito
  }

  // Renderizado condicional si no hay conexión a internet
  if (!netState) {
    return (
      <IonPage>
        <Header pageName="Crear Ticket" />
        <IonHeader>
            <IonToolbar>
                <IonButtons slot="start">
                    {/* Botón para volver a la vista anterior (probablemente la lista) */}
                    <IonBackButton defaultHref="/pqrs" />
                </IonButtons>
                <IonTitle>Crear Nuevo PQRS</IonTitle>
            </IonToolbar>
        </IonHeader>
        <IonContent className="pqrs-content ion-padding">
          <h3 className="disconnect">¡Comprueba tu conexión de internet!</h3>
        </IonContent>
        {/* Renderiza el Footer si lo usas */}
        <Footer />
      </IonPage>
    );
  }

  // Renderizado principal del formulario
  return (
    <IonPage>
       <IonHeader>
           <IonToolbar>
               <IonButtons slot="start">
                   <IonBackButton defaultHref="/pqrs" />
               </IonButtons>
               <IonTitle>Crear Nuevo PQRS</IonTitle>
           </IonToolbar>
       </IonHeader>
      <IonContent className="pqrs-content ion-padding" id="create-pqrs">

        {/* Campo Nombre */}
        <IonItem>
          <IonLabel position="stacked">Nombre</IonLabel>
          {/* Si el nombre viene del perfil, hacerlo de solo lectura */}
          <IonInput value={formData.name} onIonChange={(e) => handleChange(e, 'name')} readonly={!!profileData.full_name} />
        </IonItem>

        {/* Campo Correo electrónico */}
        <IonItem>
          <IonLabel position="stacked">Correo electrónico</IonLabel>
          <IonInput type="email" value={formData.email} onIonChange={(e) => handleChange(e, 'email')} readonly={!!profileData.email}/>
        </IonItem>

        {/* Campo Teléfono */}
        <IonItem>
          <IonLabel position="stacked">Teléfono</IonLabel>
          <IonInput type="tel" value={formData.phone} onIonChange={(e) => handleChange(e, 'phone')} readonly={!!profileData.phone}/>
        </IonItem>

        {/* Campo Propiedad (mostrar solo si existe en el perfil) */}
        {formData.propertyName && (
          <IonItem>
            <IonLabel position="floating">Propiedad</IonLabel>
            <IonInput value={formData.propertyName} readonly />
          </IonItem>
        )}

        {/* Campo Tipo de solicitud */}
        <IonItem>
          <IonLabel>Tipo de solicitud</IonLabel>
          <IonSelect value={formData.type} placeholder="Selecciona uno" onIonChange={(e) => handleChange(e, 'type')} interface="action-sheet">
            <IonSelectOption value="ticket_type_peticion">Petición</IonSelectOption>
            <IonSelectOption value="ticket_type_queja">Queja</IonSelectOption>
            <IonSelectOption value="ticket_type_reclamo">Reclamo</IonSelectOption>
            <IonSelectOption value="ticket_type_sugerencia">Sugerencia</IonSelectOption>
          </IonSelect>
        </IonItem>

        {/* Campo Mensaje */}
        <IonItem>
          <IonLabel position="floating">Mensaje</IonLabel>
          <IonTextarea rows={6} value={formData.message} onIonChange={(e) => handleChange(e, 'message')} />
        </IonItem>

        {/* Botón de envío */}
        <IonButton expand="block" onClick={handleSubmit} disabled={isSubmitting} className="ion-margin-top">
            {/* Mostrar spinner si está enviando, si no, el texto */}
            {isSubmitting ? <IonSpinner name="crescent" /> : 'Enviar PQRS'}
        </IonButton>

        {/* Componente de Alerta */}
        <IonAlert
          isOpen={showAlert}
          onDidDismiss={handleAlertDismiss} // Usar la función personalizada para manejar el cierre
          header="Resultado" // Título de la alerta
          message={alertMsg} // Mensaje dinámico
          buttons={['OK']} // Botón para cerrar
        />
      </IonContent>
      {/* Renderiza el Footer si lo usas */}
      <Footer />
    </IonPage>
  );
};

export default CreateTicket; // Exportar el componente